<template>
    <div class="container">
        <el-card shadow="never" class="rehearsal-list">
            <el-radio-group v-model="tabType" size="small" class="m-b">
                <el-radio-button label="num">按答题量排名</el-radio-button>
                <el-radio-button label="yes">按答对数排名</el-radio-button>
            </el-radio-group>
            <div class="fgx m-b"></div>
            <rehearsalRanking></rehearsalRanking>
        </el-card>
    </div>
</template>
<script>
import rehearsalRanking from "./components/rehearsal-ranking";
export default {
    data() {
        return {
            data: [],
            tabType: "num"
        };
    },
    components: {
        rehearsalRanking
    }
};
</script>
<style lang="less">
.rehearsal-list {
    margin-top: 20px;
    min-height: 500px;
    .fgx {
        border-bottom: 1px solid #ccc;
        width: 100%;
    }
    .m-b {
        margin-bottom: 20px;
    }
}
</style>